'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const GridConstants = {
  /**
   * The maximum width that a grid should render at in most
   * circumstances. When the screen is wider than this width,
   * the grid should be centered within the viewport.
   */
  maxWidth: 1230,
  /**
   * The base unit to use for spacing. Every gutter
   * should be a multiple of this number.
   */
  gapBaseUnit: 5,
  /**
   * The gutter width to use between columns on desktop
   * in most circumstances.
   */
  desktopGap: 30,
  /**
   * The gutter width to use between columns on tablets
   * in most circumstances.
   */
  tabletGap: 30,
  /**
   * The gutter width to use between columns on mobile
   * in most circumstances.
   */
  mobileGap: 20
};

exports.GridConstants = GridConstants;
//# sourceMappingURL=constants.cjs.js.map
